import { ContactBlock } from "../components/ContactBlock";

export default function ContactPage() {
  return (
    <div className="pt-28 md:pt-32 px-5 md:px-10 pb-10 md:pb-16">
      <div className="max-w-[1440px] mx-auto">
        <ContactBlock />
      </div>
    </div>
  );
}
